/**
 * Date manipulation or formatting
 * @namespace DateUtils
 */

/* Plugins */
import moment from 'moment-timezone';

export default class DateUtils {
    /**
     * Format Date 
     * @param {String} date
     * @param {String} timeZone
     * @param {String} format
     * @param {Object} options - Additional options {originDateFormat: ''}
     */
    static dateFormat({date = null, format = 'MM/DD/YYYY', timeZone = "America/Denver", options = {originDateFormat : '', }} = {}) {
        console.log('dateFormat', date, format, timeZone, options);
        if(options.originDateFormat) {
            if(moment(date, options.originDateFormat).isValid()) {
                console.log('dateFormat with originDateFormat', date, options.originDateFormat, format, timeZone);
                if(!timeZone) return moment(date, options.originDateFormat).format(format);
                return moment(date, options.originDateFormat).tz(timeZone).format(format);
            } else if(moment(date).isValid()) {
                console.log('dateFormat without originDateFormat', date, format, timeZone);
                if(!timeZone) return moment(date).format(format);
                return moment(date).tz(timeZone).format(format);
            } else {
                if(!timeZone) return moment().format(format);
                return moment().tz(timeZone).format(format);
            }
        }

        if(!timeZone) return moment(date).format(format);
        return moment(date).tz(timeZone).format(format);
    }

    /**
     * Get difference between two dates
     * @param {String} startDate - Date to compare
     * @param {String} endDate - Date to compare
     * @param {String} unit - 'days', 'months', 'years', 'hours', 'minutes', 'seconds'
     * @param {String} startDateOriginFormat - Date format to parse startDate
     * @param {String} endDateOriginFormat - Date format to parse endDate
     */
    static dateDiff({startDate = null, endDate = null, unit = 'days', timeZone = "America/Denver", startDateOriginFormat, endDateOriginFormat} = {}) {
        if(!timeZone) timeZone = moment.tz.guess();
        if(!startDate || !endDate) return 0;
        if(startDateOriginFormat && endDateOriginFormat) return moment(endDate, endDateOriginFormat).tz(timeZone).diff(moment(startDate, startDateOriginFormat).tz(timeZone), unit);
        if(startDateOriginFormat) return moment(endDate).tz(timeZone).diff(moment(startDate, startDateOriginFormat).tz(timeZone), unit);
        if(endDateOriginFormat) return moment(endDate, endDateOriginFormat).tz(timeZone).diff(moment(startDate).tz(timeZone), unit);
        return moment.tz(endDate, timeZone).diff(moment.tz(startDate, timeZone), unit);
    }

    /**
     * Is same or after date
     * @param {String} date - Date to compare
     * @param {String} compareDate - Date to compare
     * @param {String} unit - 'days', 'months', 'years', 'hours', 'minutes', 'seconds'
     * @param {String} timeZone - Timezone to use
     * @param {String} dateOriginFormat - Date format to parse date
     * @param {String} compareDateOriginFormat - Date format to parse compareDate
     * @return {Boolean} - True if date is same or after compareDate
     */
    static isSameOrAfter({date = null, compareDate = null, unit = 'days', timeZone = "America/Denver", dateOriginFormat, compareDateOriginFormat} = {}) {
        if(!timeZone) timeZone = moment.tz.guess();
        if(!date || !compareDate) return false;
        if(dateOriginFormat && compareDateOriginFormat) return moment(date, dateOriginFormat).tz(timeZone).isSameOrAfter(moment(compareDate, compareDateOriginFormat).tz(timeZone), unit);
        if(dateOriginFormat) return moment(date, dateOriginFormat).tz(timeZone).isSameOrAfter(moment(compareDate).tz(timeZone), unit);
        if(compareDateOriginFormat) return moment(date).tz(timeZone).isSameOrAfter(moment(compareDate, compareDateOriginFormat).tz(timeZone), unit);
        return moment.tz(date, timeZone).isSameOrAfter(moment.tz(compareDate, timeZone), unit);
    }

    /**
     * Is same or before date
     * @param {String} date - Date to compare
     *  @param {String} compareDate - Date to compare
     * @param {String} unit - 'days', 'months', 'years', 'hours', 'minutes', 'seconds'
     * @param {String} timeZone - Timezone to use
     * @param {String} dateOriginFormat - Date format to parse date
     * @param {String} compareDateOriginFormat - Date format to parse compareDate
     * @return {Boolean} - True if date is same or before compareDate
     * 
     */
    static isSameOrBefore({date = null, compareDate = null, unit = 'days', timeZone = "America/Denver", dateOriginFormat, compareDateOriginFormat} = {}) {
        if(!timeZone) timeZone = moment.tz.guess();
        if(!date || !compareDate) return false;
        if(dateOriginFormat && compareDateOriginFormat) return moment(date, dateOriginFormat).tz(timeZone).isSameOrBefore(moment(compareDate, compareDateOriginFormat).tz(timeZone), unit);
        if(dateOriginFormat) return moment(date, dateOriginFormat).tz(timeZone).isSameOrBefore(moment(compareDate).tz(timeZone), unit);
        if(compareDateOriginFormat) return moment(date).tz(timeZone).isSameOrBefore(moment(compareDate, compareDateOriginFormat).tz(timeZone), unit);
        return moment.tz(date, timeZone).isSameOrBefore(moment.tz(compareDate, timeZone), unit);
    }

    /**
     * Is same date
     * @param {String} date - Date to compare
     * @param {String} compareDate - Date to compare
     * @param {String} unit - 'days', 'months', 'years', 'hours', 'minutes', 'seconds'
     * @param {String} timeZone - Timezone to use
     * @param {String} dateOriginFormat - Date format to parse date
     * @param {String} compareDateOriginFormat - Date format to parse compareDate
     * @return {Boolean} - True if date is same compareDate
     * 
     */
    static isSame({date = null, compareDate = null, unit = 'days', timeZone = "America/Denver", dateOriginFormat, compareDateOriginFormat} = {}) {
        
        if(!timeZone) timeZone = moment.tz.guess();
        if(!date || !compareDate) return false;
        console.log('same date', moment.tz(date, timeZone).isSame(moment.tz(compareDate, timeZone), unit), unit)
        if(dateOriginFormat && compareDateOriginFormat) return moment(date, dateOriginFormat).tz(timeZone).isSame(moment(compareDate, compareDateOriginFormat).tz(timeZone), unit);
        if(dateOriginFormat) return moment(date, dateOriginFormat).tz(timeZone).isSame(moment(compareDate).tz(timeZone), unit);
        if(compareDateOriginFormat) return moment(date).tz(timeZone).isSame(moment(compareDate, compareDateOriginFormat).tz(timeZone), unit);
        return moment.tz(date, timeZone).isSame(moment.tz(compareDate, timeZone), unit);
    }

    /**
     * Set date, month, year, hour, minute, second
     * @param {String} date - Date to set
     * @param {Number} year - Year to set
     * @param {Number} month - Month to set (0-11)
     * @param {Number} day - Day to set (1-31)
     * @param {Number} hour - Hour to set (0-23)
     * @param {Number} minute - Minute to set (0-59)
     * @param {Number} second - Second to set (0-59)
     * @param {String} timeZone - Timezone to use
     * @param {string} originDateFormat - Date format to parse date
     * @param {string} format - Date format to return
     */
    static setDate({date = null, year = null, month = null, day = null, hour = null, minute = null, second = null, originDateFormat, timeZone, format} = {}) {
        if(!date) return null;
        let m = moment(date, originDateFormat || 'YYYY-MM-DD').tz(timeZone ||moment.tz.guess());
        if(year !== null) m.year(year);
        if(month !== null) m.month(month);
        if(day !== null) m.date(day);
        if(hour !== null) m.hour(hour);
        if(minute !== null) m.minute(minute);
        if(second !== null) m.second(second);
        console.log('moment', m);

        return m.format(format || 'MM/DD/YYYY');
    }
}